import Image from "next/image";
import React from "react";
import searchNotFoundImage from "@/public/images/searchNotFound.svg";
import { useTranslate } from "@/components/base/providers/TranslateProv";

type Props = {};

const NoArticlesFound = (props: Props) => {
  const { locale } = useTranslate();
  return (
    <div className="w-full p-5 rounded-xl flex-col justify-center items-center gap-11 inline-flex mb-8">
      <div className="relative">
        <Image
          src={searchNotFoundImage}
          alt="No Articles"
          className="w-full h-full"
          width={200}
          height={165}
        />
      </div>
      <div className="flex-col justify-center items-center gap-[26px] flex">
        <div className="text-center text-[#222222] text-[28px] font-bold">
          {locale === "ar" ? "لا توجد مقالات لهذه الفئة" : "No articles found for this category"}
        </div>
        <div className="text-center text-[#6c7278] text-[16px]">
          {locale === "ar"
            ? "لم يتم العثور على مقالات في هذه الفئة أو الفئة الفرعية المحددة."
            : "No articles were found in the selected category or subcategory."}
        </div>
      </div>
    </div>
  );
};

export default NoArticlesFound;